import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class SummaryMainScore extends React.Component {
  render() {
    let data = this.props.data;
    let workflow = data.workflow;
    
    let postAry = [];
    data.report.list.map((d) => { if( postAry.indexOf(d.insta_user_id) == -1 ) postAry.push(d.insta_user_id); });
    
    let followers_count = 0;
    let assign_count = 0;
    for( let i in workflow.influencers ){
      try {
        let d = workflow.influencers[i];
        if( d.status.is_assign === 1 && postAry.indexOf(d.insta_user_id) >= 0 ){
          assign_count++;
          followers_count += d.followers;
        }
      } catch(e) {}
    }
    
    let reach_count = 0;
    let engagement_count = 0;
    
    data.report.list.map((d) => {
      if( d.reach    != null ) reach_count      += d.reach;
      if( d.likes    != null ) engagement_count += d.likes;
      if( d.comments != null ) engagement_count += d.comments;
      //if( d.saved    != null ) engagement_count += d.saved;
    });
    
    let reach_per = ((reach_count / followers_count) * 100);
    let engagement_per = ((engagement_count / followers_count) * 100);
    
    if( isNaN(reach_per) || reach_per == 'Infinity' ) reach_per = 0;
    if( isNaN(engagement_per) || engagement_per == 'Infinity' ) engagement_per = 0;
    
    let items = [
      { id: 'influencers', name: '合計起用フォロワー数', value: followers_count,  type: 'person' },
      { id: 'survival',    name: '合計起用人数',         value: postAry.length,   type: 'person', post: (data.report.list.length), help: <p>キャンペーン内の全候補者（候補者、対象外、アサイン対象の合計）<br />に対する「アサイン対象人数」を割った残り候補者の割合</p> },
      { id: 'reply',       name: '合計リーチ数',         value: reach_count,      type: 'count' , percent: reach_per,      help: <p>アサイン対象者に対して「何かしらの返信があった人数」の割合<br />（辞退連絡等も含む）</p> },
      { id: 'permission',  name: '合計エンゲージメント', value: engagement_count, type: 'count',  percent: engagement_per, help: <p>アサイン対象者に対して「案件OK人数」の割合<br />（ワークフローで「2.投稿まで」以降のユーザーが対象）</p> },
    ];
    
    return (
      <div className="report-main-score">
        { items.map((d, key) => {
          return (
            <div key={key} className="score-item">
              <h3>
                <span>{d.name}</span>
                { (d.help != undefined) &&
                  <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>{d.help}</Tooltip>}>
                    <i className="material-icons">info</i>
                  </OverlayTrigger>
                }
              </h3>
              <h4>
                {Utils.viewInt(d.value)}
                {(d.type == 'percent') && <span>%</span> }
                {(d.type == 'person') && <span>人</span> }
              </h4>
              {(d.count != undefined) && <h5>({d.count}人)</h5> }
              {(d.post != undefined) && <h5>(投稿数: {d.post})</h5> }
              {(d.percent != undefined) && <h5>({d.percent.toFixed(2)}%)</h5> }
            </div>
          );
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryMainScore;